import pad from './pad'

const twoDigitPadder = pad(2)

function unix <T extends string | number> (moment: T) : T extends string ? number : string {
  let formatted

  if (typeof moment === 'string') {
    formatted = new Date(moment).getTime() / 1000
  } else {
    const date = new Date((moment as number) * 1000)
    const year = date.getFullYear()
    const month = twoDigitPadder(date.getMonth() + 1)
    const day = twoDigitPadder(date.getDate())

    formatted = `${year}-${month}-${day}`
  }

  return formatted
}

export default unix



// WEBPACK FOOTER //
// ./src/utils/unix.ts